import React from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';
import { RiUserVoiceLine } from 'react-icons/ri';

const TextToSpeech = ({ inputText }) => {
  const { speak } = useSpeechSynthesis();
  return (
    <RiUserVoiceLine onClick={() => speak({ text: inputText })}>
      Speak
    </RiUserVoiceLine>
  );
};

export default TextToSpeech;
